import PropTypes from 'prop-types';
import productMutation from '@/api/mutitations/product';
import companyMutation from '@/api/mutitations/company';
import ProcessNotification from '@/components/processNotification';
import { useEffect } from 'react';
import prepareTranslate from '@/helpers/dictionary';
import authQuery from '@/api/queries/auth';
import { useModalQueue } from '@/hooks/FileUploadResponseContext';
import { SSE_TYPES } from '../../helpers/enums';
import Modal from '../Modal/Index';
import RowErrorsModal from '../RowErrorsModal';

const processSSEData = async (obj) => {
  const {
    t,
    e,
    companyMutate,
    productMutate,
    userData,
    showModal,
    closeModal,
  } = obj;

  const notificationId = (Math.random() + 1).toString(36).substring(7);

  const {
    success,
    data,
    error,
    userId,
  } = JSON.parse(e.data);

  let Component;
  if (userId !== userData._id) {
    return;
  }

  const { type } = data || {};

  if (!success) {
    const { code } = error;
    const {
      rule: ruleDetails,
      identifiers,
      collection,
      rowsErrors,
    } = data;

    const ruleTitle = ruleDetails.title;

    if (code === 501 && collection === 'agents' && type === SSE_TYPES.process) {
      const companySet = new Set();
      const productSet = new Set();
      const foundCompanies = new Map();
      const foundProducts = new Map();

      const unAttributedIdentifiers = [...identifiers];
      const identifiersData = [];
      try {
        for (let i = 0; i < unAttributedIdentifiers.length; i += 1) {
          const {
            additionalData: { companyId, productId },
          } = unAttributedIdentifiers[i];

          companySet.add(companyId);
          productId.forEach((id) => productSet.add(id));
        }

        await Promise.all([...companySet.values()].map(async (id) => {
          const companyData = await companyMutate({ id });
          foundCompanies.set(id, companyData);
        }));

        await Promise.all([...productSet.values()].map(async (id) => {
          const companyData = await productMutate({ id });
          foundProducts.set(id, companyData);
        }));

        for (let i = 0; i < unAttributedIdentifiers.length; i += 1) {
          const {
            additionalData: { companyId, productId },
            identifierNumber,
            identifierQuery,
            year,
            month,
            origionYear,
            origionMonth,
            referenceYear,
          } = unAttributedIdentifiers[i];

          const { hebrew: companyHebrew } = foundCompanies.get(companyId);

          let productData = [];
          productData = productId.map((id) => {
            const product = foundProducts.get(id);
            return { id, hebrew: product?.hebrew };
          });

          identifiersData.push({
            company: { id: companyId, hebrew: companyHebrew },
            product: productData,
            identifierQuery,
            identifierNumber,
            year,
            month,
            origionYear,
            origionMonth,
            referenceYear,
          });
        }
        Component = <ProcessNotification
          identifiers={identifiersData}
          ruleDetails={ruleDetails}
          notificationId={notificationId}
          userId={userId}
          onClose={closeModal}
        />;
      } catch {
        Component = <Modal
          opened={true}
          label={t('global.process.failure.title')}
          message={t('global.process.failure.message', [ruleTitle])}
          withCloseButton={true}
          onClose={closeModal}
        />;
      }
    } else if (code === 702 && type === SSE_TYPES.process) {
      Component = <RowErrorsModal
          rowsErrors={rowsErrors}
          onClose={closeModal}
          rule={ruleDetails}
      />;
    } else {
      Component = <Modal
        opened={true}
        label={t('global.process.failure.title')}
        message={t('global.process.failure.message', [ruleTitle])}
        onClose={closeModal}
        withCloseButton={true}
        variant='error'
      />;
    }
  } else {
    const { rule: ruleDetails } = data;

    if (type === SSE_TYPES.process) {
      Component = <Modal
        opened={true}
        label={t('global.process.success.title')}
        message={t('global.process.success.message', [ruleDetails.title])}
        withCloseButton={true}
        onClose={closeModal}

      />;
    }
  }

  showModal({
    id: 'example-modal',
    component: Component,
  });
};

const SSEHandler = (props) => {
  const { event } = props;
  const { showModal, closeModal } = useModalQueue();

  const t = prepareTranslate();

  const { mutateAsync: companyMutate } = companyMutation.useFindById();
  const { mutateAsync: productMutate } = productMutation.useFindById();
  const { data: userData } = authQuery.useProfile();

  useEffect(() => {
    const processObj = {
      t,
      companyMutate,
      productMutate,
      e: event,
      userData,
      showModal,
      closeModal,
    };

    if (event) {
      processSSEData(processObj);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  return null;
};

SSEHandler.propTypes = {
  event: PropTypes.object,
  t: PropTypes.func,
};

export default SSEHandler;
